import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

import styled from 'styled-components';

import CardBox from '../components/CardBox';
import Pagenation from '../components/Pagenation';

function List() {
    const [list, setList] = useState([]);
    const [navList, setNavList] = useState([]);
    const [articleCount, setArticleCount] = useState(0);

    const [searchParams, setSearchParams] = useSearchParams({ s: '', f: '' });
    const s = searchParams.get('s');
    const f = searchParams.get('f');
    const p = searchParams.get('p');

    const EXPOSURE_ARTICLE_NUMBER = 20;

    useEffect(() => {
        let start_index = !p ? 0 * EXPOSURE_ARTICLE_NUMBER: (p - 1) * EXPOSURE_ARTICLE_NUMBER;

        fetch('https://api.kerbo.co.kr/list?s=' + s + '&f=' + f + '&p=' + start_index, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((res) => {
                if (res.ok) {
                    res.json().then((data) => {
                        setArticleCount(parseInt(data['ARTICLE_COUNT']));
                        setList(data['SEARCH_RESULT']);
                    });
                }
            });
    }, [s, f, p]);

    useEffect(() => {
        fetch('https://api.kerbo.co.kr/categories', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((res) => {
            if (res.ok) {
                res.json().then((data) => {
                    setNavList(data);
                });
            }
        });
    }, []);

    const delete_article = (article_id, idx) => {
        if (!window.confirm('정말로 삭제하시겠습니까?')) {
            return false;
        }

        const session_aid = window.sessionStorage.getItem('aid');
        const session_authCode = window.sessionStorage.getItem('authcode');

        fetch(
            'https://api.kerbo.co.kr/article/' +
                article_id +
                '?ai=' +
                session_aid +
                '&ac=' +
                session_authCode,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        ).then((res) => {
            if (res.ok) {
                let copyList = list.slice();
                copyList.splice(idx, 1);
                setList(copyList);
                alert('삭제되었습니다.');
            }
        });
    };

    const setQuerySearch = (e) => {
        if (e.key === 'Enter') {
            setSearchParams({ s: e.target.value, f });
        }
    };

    const setQueryFilter = (e) => {
        setSearchParams({ s, f: e.target.dataset.id });
    };

    return (
        <CardlistWapper>
            <ActionSection>
                <Search placeholder="Search" defaultValue={s} onKeyPress={setQuerySearch}></Search>
                <Filter>
                    <FilterButton>Filter</FilterButton>
                    <FilterBox>
                        <FilterOption data-id={''} onMouseDown={setQueryFilter} selected={'' === f}>
                            모두
                        </FilterOption>
                        {navList.map((navData, idx) => (
                            <FilterOption
                                key={navData['CATEGORY_ID']}
                                data-id={navData['CATEGORY_ID']}
                                onMouseDown={setQueryFilter}
                                selected={String(navData['CATEGORY_ID']) === f}
                            >
                                {navData['CATEGORY_NAME']}
                            </FilterOption>
                        ))}
                    </FilterBox>
                </Filter>
            </ActionSection>
            <Link to="/edit/new">
                <AddArticleButton>
                    <AddImage src="/img/add_article.jpg"></AddImage>
                    <p>새로운 글 추가</p>
                </AddArticleButton>
            </Link>
            {list.length === 0 ? (
                <div>검색된 글이 없습니다.</div>
            ) : (
                list.map((data, idx) => (
                    <CardBox
                        key={data['ARTICLE_ID']}
                        type="list"
                        idx={idx}
                        data={data}
                        delete_article={delete_article}
                    />
                ))
            )}
            <Pagenation article_count={articleCount} />
        </CardlistWapper>
    );
}

export default List;

const CardlistWapper = styled.section`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 20px;

    margin: 0px 160px;
    margin-bottom: 40px;
    box-sizing: border-box;

    min-width: 1035px;
`;

const ActionSection = styled.section`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 20px;

    height: 46px;
`;

const Search = styled.input`
    width: 242px;

    background-color: #f5f5f5;
    border: none;
    border-radius: 23px;
    outline: none;

    padding-left: 18px;
`;

const Filter = styled.section`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-end;
    gap: 10px;

    width: 100px;
`;

const FilterButton = styled.button`
    width: 100px;
    height: 46px;

    flex-shrink: 0;

    border: none;
    border-radius: 8px;

    color: #747474;

    cursor: pointer;

    &:focus {
        background-color: #d3d3d3;
    }
`;

const FilterBox = styled.div`
    display: none;
    flex-direction: column;
    flex-wrap: nowrap;

    width: 260px;

    padding: 8px 0px;
    box-sizing: border-box;

    border-radius: 8px;

    flex-shrink: 0;

    background-color: #eaeaea;

    box-shadow: 0px 3px 6px #00000040;

    z-index: 10;

    ${FilterButton}:focus ~ & {
        display: flex;
    }
`;

const FilterOption = styled.p`
    width: 100%;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${props => props.selected ? '#d3d3d3' : ''};

    cursor: pointer;

    &:hover {
        background-color: #d3d3d3;
    }
`;

const AddArticleButton = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    gap: 18px;

    width: 100%;
    height: 130px;

    border: none;
    border-radius: 10px;

    background-color: #f2f2f2;

    overflow: hidden;

    font-size: 20px;
    color: #6e6e6e;
`;

const AddImage = styled.img`
    width: 240px;
    height: 100%;
`;
